import { MenuButton } from './menu-button';
import { NavigationSubMenuButton } from './navigation-sub-menu-button';
import { Prefetch } from './prefetch';
import { SiteTitle } from './site-title';

new MenuButton();
new SiteTitle();
new NavigationSubMenuButton();
new Prefetch();
